import { MiroIcon } from "#components/ui/MiroIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const miroManifest: IntegrationManifest = {
    key: "miro",
    displayName: "Miro",
    nameKey: "channels.miro",
    descriptionKey: "miroDescription",
    trayDescriptionKey: "composerTrayDescriptions.miro",
    cardDescriptionKey: "connectIntegration.descriptions.miro",
    connectedContentKeys: ["miroBoards"],
    brandColor: "#FFDD33",
    // White on #FFDD33 is 1.34:1 — below AA for the body-xs row, so the pill keeps the dark foreground.
    brandForegroundColor: "core_abyss",
    iconUrl: IconAssets.Miro,
    iconUrlAlt: IconAssets.MiroAlt,
    glyph: MiroIcon,
    channelType: "UserMiroMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
